import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, LogIn } from "lucide-react";
import { images } from "../data/content";

const navItems = [
  { to: "/", label: "Home", tid: "home" },
  { to: "/history", label: "History", tid: "history" },
  { to: "/freemasonry", label: "Freemasonry", tid: "freemasonry" },
  { to: "/news", label: "News", tid: "news" },
  { to: "/visit", label: "Visit Us", tid: "visit" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled
          ? "border-b border-gold/30 bg-ivory/95 shadow-[0_10px_30px_-18px_rgba(10,36,99,0.4)] backdrop-blur-md"
          : "bg-ivory/80 backdrop-blur-sm"
      }`}
      data-testid="site-header"
    >
      <div className="container-lodge flex h-20 items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="header-logo-link">
          <img src={images.crestSeal} alt="Coat of arms of The Zetland in the East Lodge No. 508" className="h-12 w-12" />
          <span className="hidden font-display text-lg leading-tight text-sapphire-deep sm:block">
            The Zetland in the East
            <span className="block font-sans text-[10px] uppercase tracking-[0.3em] text-gold-deep">
              Lodge No. 508 E.C.
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-9 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `relative font-sans text-sm font-semibold uppercase tracking-widest transition-colors ${
                  isActive ? "text-gold-deep" : "text-sapphire-deep/75 hover:text-gold-deep"
                }`
              }
              data-testid={`nav-${item.tid}`}
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/login"
            className="flex items-center gap-2 rounded-full bg-sapphire-deep px-5 py-2 text-xs font-semibold uppercase tracking-widest text-parchment transition-all hover:bg-sapphire-mid"
            data-testid="member-login-link"
          >
            <LogIn size={15} /> Member Login
          </Link>
        </nav>

        <button
          className="text-sapphire-deep md:hidden"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-gold/20 bg-ivory md:hidden" data-testid="mobile-menu">
          <nav className="container-lodge flex flex-col gap-1 py-4">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `rounded-lg px-4 py-3 font-sans text-sm font-semibold uppercase tracking-widest ${
                    isActive ? "bg-sapphire-deep/5 text-gold-deep" : "text-sapphire-deep/80"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/login"
              className="mt-2 flex items-center gap-2 rounded-lg bg-sapphire-deep px-4 py-3 font-sans text-sm font-semibold uppercase tracking-widest text-parchment"
            >
              <LogIn size={16} /> Member Login
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
